module.exports = __webpack_public_path__ + "img/server_status.255498e5.png";